/**
 * Let this page play sound, from inside a tap.
 *
 * Phone browsers - iPhone Safari above all - refuse to play any sound the page
 * did not start from a tap or click, and a tap only counts for an instant: it is
 * gone by the time the meeting has finished asking the server for permission and
 * connecting. So the very first thing the Join button does, before anything is
 * awaited, is play a moment of silence. After that the page is allowed to play
 * the meeting's audio when it arrives.
 *
 * Harmless on a computer, and it never throws.
 */

// One silent sample, as a tiny WAV, for browsers that only unlock through an <audio> element.
const SILENCE = 'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YQAAAAA=';

export const unlockAudio = () => {
    try {
        const Context = window.AudioContext || window.webkitAudioContext;
        if (Context) {
            const context = new Context();
            if (context.resume) context.resume().catch(() => { });
            const source = context.createBufferSource();
            source.buffer = context.createBuffer(1, 1, 22050);
            source.connect(context.destination);
            source.start(0);
            setTimeout(() => { try { context.close(); } catch { /* already closed */ } }, 500);
        }
    } catch { /* no Web Audio here */ }

    try {
        const silent = new Audio(SILENCE);
        silent.volume = 0;
        const played = silent.play();
        if (played && played.catch) played.catch(() => { });
    } catch { /* no audio element here */ }
};

export default unlockAudio;
